import { CreateDroneModelRequest } from '../request-models/create-drone-model-request.model';
import { DroneManufacturerRequest } from '../request-models/drone-manufacturer-request.model';
import { DroneModelRequest } from '../request-models/drone-model-request.model';
import { omitUndefined } from './wire-value-utils';

/** Builds the POST / PUT /admin/drone-manufacturers body: only the hub's writable fields that are set. */
export function toDroneManufacturerRequest(fields: DroneManufacturerRequest): DroneManufacturerRequest {
  return omitUndefined<DroneManufacturerRequest>({
    name: fields.name,
    description: fields.description,
    url: fields.url,
    logoUrl: fields.logoUrl,
  });
}

/** Builds the PUT /admin/drone-models/:id body: only the hub's writable fields that are set (never the manufacturer). */
export function toDroneModelRequest(fields: DroneModelRequest): DroneModelRequest {
  return omitUndefined<DroneModelRequest>({
    modelName: fields.modelName,
    description: fields.description,
    maxTakeoffWeightLbs: fields.maxTakeoffWeightLbs,
    imageUrl: fields.imageUrl,
  });
}

/** Builds the POST /admin/drone-models body: the writable fields plus `manufacturerId`. */
export function toCreateDroneModelRequest(fields: CreateDroneModelRequest): CreateDroneModelRequest {
  return { ...toDroneModelRequest(fields), manufacturerId: fields.manufacturerId };
}
